export function getPrizeCurrency(prize: string) {
  return prize.substring(0, prize.search(/\d/))
}

export function getPrizeValue(prize: string) {
  return prize.substring(prize.search(/\d/))
}
